import React from 'react'


export default function Svg({children, ...props}) {
    return <svg xmlns="http://www.w3.org/2000/svg" {...props}>
        {children}
    </svg>
}
